/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiAlbumCollectionsIdMutationRequest, PutApiAlbumCollectionsIdMutationResponse, PutApiAlbumCollectionsIdPathParams, PutApiAlbumCollectionsId400, PutApiAlbumCollectionsId401, PutApiAlbumCollectionsId403, PutApiAlbumCollectionsId404, PutApiAlbumCollectionsId500 } from "../../types/PutApiAlbumCollectionsId.ts";
import { putApiAlbumCollectionsIdMutationResponseSchema, putApiAlbumCollectionsIdMutationRequestSchema } from "../../zod/AlbumCollectionSchemas/putApiAlbumCollectionsIdSchema.ts";

function getPutApiAlbumCollectionsIdUrl({ id }: { id: PutApiAlbumCollectionsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/album-collections/${id}` as const }  
  return res
}

/**
 * @summary Обновление выпуска
 * {@link /api/album-collections/:Id}
 */
export async function putApiAlbumCollectionsId({ id, data }: { id: PutApiAlbumCollectionsIdPathParams["Id"]; data?: PutApiAlbumCollectionsIdMutationRequest }, config: Partial<RequestConfig<PutApiAlbumCollectionsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiAlbumCollectionsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiAlbumCollectionsIdMutationResponse, ResponseErrorConfig<PutApiAlbumCollectionsId400 | PutApiAlbumCollectionsId401 | PutApiAlbumCollectionsId403 | PutApiAlbumCollectionsId404 | PutApiAlbumCollectionsId500>, PutApiAlbumCollectionsIdMutationRequest>({ method : "PUT", url : getPutApiAlbumCollectionsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiAlbumCollectionsIdMutationResponseSchema.parse(res.data)
}